function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from 'react';
import BootstrapAlert from 'react-bootstrap/Alert';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMount } from 'react-use';
import classnames from 'classnames';
import Icon from '../icon/Icon';
var getAlertIcon = function(variant) {
    switch(variant){
        case 'info':
            return 'information';
        default:
            return '';
    }
};
var Alert = function() {
    var history = useHistory();
    var _useState = _sliced_to_array(useState(false), 2), open = _useState[0], setOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        message: '',
        variant: ''
    }), 2), alertDetails = _useState1[0], setAlertDetails = _useState1[1];
    var alertReducer = useSelector(function(state) {
        return state.alerts.alert;
    });
    var handleClose = function() {
        setOpen(false);
    };
    useMount(function() {
        return history.listen(function(location, action) {
            if (action === 'PUSH') {
                handleClose();
            }
        });
    });
    useEffect(function() {
        if (alertReducer.message && alertReducer.variant) {
            setAlertDetails(alertReducer);
            setOpen(true);
            if (alertReducer.dismissible) {
                setTimeout(handleClose, 6000);
            }
        } else {
            handleClose();
        }
    }, [
        alertReducer
    ]);
    var _alertDetails_icon, _alertDetails_icon1;
    return /*#__PURE__*/ React.createElement(BootstrapAlert, {
        className: classnames(_define_property({
            hasIcon: (_alertDetails_icon = alertDetails.icon) !== null && _alertDetails_icon !== void 0 ? _alertDetails_icon : getAlertIcon(alertDetails.variant)
        }, alertDetails.className, alertDetails.className)),
        show: open,
        variant: alertDetails.variant,
        onClose: handleClose,
        onClick: handleClose,
        dismissible: alertReducer.dismissible
    }, (getAlertIcon(alertDetails.variant) || alertDetails.icon) && /*#__PURE__*/ React.createElement(Icon, {
        icon: (_alertDetails_icon1 = alertDetails.icon) !== null && _alertDetails_icon1 !== void 0 ? _alertDetails_icon1 : getAlertIcon(alertDetails.variant)
    }), alertDetails.message);
};
export default Alert;
